import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
// import { useGetConsentFormDetailsQuery, useSaveConsentFormMutation } from 'store/services/consentForm';
import parse from "html-react-parser";
import LoadingIndicator from 'components/shared/LoadingIndicator';
import { usePreviewConsentFormQuery } from 'store/services/appointment';
import { parseConsentForm } from "helpers/consentForm";
import ErrorComponent from "components/shared/ErrorComponent";
import {Col , Row} from "react-bootstrap"
const AppointmentFormsView = () => {

    const { id, mode } = useParams();
    const navigate = useNavigate();

    const { data, isLoading } = usePreviewConsentFormQuery({ id, mode });
    // const { data, isLoading } = usePreviewConsentFormQuery({ id });
    const [errorMessage, setErrorMessage] = useState(null);
    const isSubmitted = true

    const parsedHtml = useMemo(() => {
        if(!data) {
            return null;
        }
        let submittedValues = null;
        if(mode !== "preview") {
            try {
                submittedValues = JSON.parse(data?.formAssigned[0]?.submission || {});
            } catch(err) {
                console.error("Error viewing consent form", err);
            }
        }
        return parseConsentForm(data?.consent_form, submittedValues, isSubmitted);
    }, [data])


    return (
        isLoading ? <LoadingIndicator /> : <div className='consent-form-wrapper'>
            <Col lg="12 border-bottom py-2" style={{"background": "white","position":"fixed"}}>
                    <Row>
                            <Col xs={2}>
                            <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                                <div className="left mt-2 px-4">
                                <Link
                                    className="themeBlue fw-sbold"
                                    style={{ textDecoration: "underline" }}
                                    to={-1}
                                    >
                                    <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                                    Back
                                </Link>
                                </div>                       
                            </div>
                            </Col>
                            <Col xs={8}>
                                <h5 class="mt-2 fw-bold text-capitalize">{data?.title || "--"}</h5>
                            </Col>
                            {/* <Col xs={4}>
                                <h5 class="mt-2 fw-bold text-capitalize">{data?.formAssigned?.verify}</h5>
                            </Col> */}
                    </Row>
            </Col>
            {parsedHtml ? (
                <div className='p-4 consent-fill-form'>
                    <form onSubmit={"handleSubmit"}>
                        {
                            parse(parsedHtml || "")
                        }
                        {/* <div className='mt-5'>
                            {errorMessage && <div className='my-2 error'>{errorMessage}</div>}
                            <Button
                                type="submit"
                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                disabled={isSubmitted || saveFormLoading}
                            >
                                {saveFormLoading ? <LoadingIndicator color='#fff' inline /> : "Submit"}
                            </Button>
                        </div> */}
                    </form>
                </div>
            ):(
                <ErrorComponent />
            )}
        </div>
    )
}

export default AppointmentFormsView